/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useMemo } from 'react';
import { difference } from '../../../../../../../utils/date.utils';
import { INotificationProps } from './types';
import { CircularAvatar } from '../../../../CustomAvatar';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { userSelectors } from '../../../../../../../app/resource/user/user.selectors';
import moment from 'moment';

export const Notification: FunctionComponent<INotificationProps> = ({ notification }) => {
  const now = moment.utc().format('YYYY-MM-DD HH:mm:ss');
  const time = useMemo(() => (notification ? difference(notification.createdAt, now) : '/'), [notification, now]);
  const user = useSelectWithParams(userSelectors.selectResourceById, notification.senderId);

  return (
    notification && (
      <>
        <div className="dropdown submenu-dots">
          <span className="dropdown-button" data-action="submenu">
            <i className="icon-dot-3 link blueGray" />
          </span>
          <ul className="dropdown-menu drop-right">
            <li>
              <span className="drop-item">Option 1</span>
            </li>
            <li>
              <span className="drop-item">Option 2</span>
            </li>
            <li>
              <span className="drop-item">Option 3</span>
            </li>
          </ul>
        </div>
        <a>
          <CircularAvatar
            src={user?.image}
            title={`${user?.firstName} ${user?.lastName}`}
            size="25"
            classes="img-fluid mr-2"
            textSizeRatio={2}
            cursorPointer={false}
          />
          <span className="drop-menu-desc">
            <span className="user-name">{notification.message}</span>
            <span className="user-time">{`${time} ago`}</span>
          </span>
        </a>
      </>
    )
  );
};
